import { selectMerchant } from "@redux";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { StyledShowImg } from "./StyledExampleActivityUpload";

interface IProps {
    handleClose: () => void;
    campaign: any;
}

const tkey = "page.uploadActivity.example";
export const ExampleUploadActivity = ({ handleClose, campaign }: IProps) => {
    //page redux
    const { themes } = useSelector(selectMerchant);

    // Translation
    const { t } = useTranslation("translation", { keyPrefix: tkey });

    return (
        <StyledShowImg themeColor={themes?.themeColor!}>
            <div className="layout-ex-img">
                <div className="title">{t("title")}</div>
                <div className="detail">{t("description")}</div>
                <div className="control-show-img">
                    <img
                        src={
                            campaign?.action?.exampleImage ||
                            "../../images/img-upload-activity-01.png"
                        }
                    />
                </div>
            </div>
            <div
                className="close-popupinvite"
                onClick={() => {
                    handleClose();
                }}
            >
                <img src="../images/ic-close-invite.svg" alt="" />
            </div>
        </StyledShowImg>
    );
};
